import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-633f208e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-order-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "service-page-title"
}
const _hoisted_3 = { class: "service-page-title" }
const _hoisted_4 = { class: "pay-type cm-ui-mt10" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "pay-type-item-right" }
const _hoisted_8 = { class: "item-header" }
const _hoisted_9 = { class: "item-desc" }
const _hoisted_10 = { class: "service-page-title" }
const _hoisted_11 = { class: "cm-ui-mt10" }
const _hoisted_12 = {
  href: "/privacy/dubateam-payment-terms.html",
  class: "cm-link-light",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ServiceEnum = _resolveComponent("ServiceEnum")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.baseInfo.current_price)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('payDetails.dialogTitle')), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "table", {}, undefined, true),
    (!_ctx.$slots.table && _ctx.baseInfo.current_price)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 1,
          width: "100%",
          data: [{}],
          "tooltip-effect": "light"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('confirmOrder.tableColProductName')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.brandConfig.client_name), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('confirmOrder.tableColOrderContent'),
              "min-width": "130px"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_ServiceEnum, {
                  group: _ctx.baseInfo.group,
                  services: _ctx.baseInfo.services,
                  "max-show-service-count": 1
                }, null, 8, ["group", "services"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('subscribeDetails.serviceYearsLabel')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.baseInfo.cycle_count) + _toDisplayString(_ctx.DateKindLabel[_ctx.baseInfo.date_kind]), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('subscribeDetails.terminalQuotaLabel')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.baseInfo.purchase_count) + _toDisplayString(_ctx.$t('subscribeDetails.terminalSuffix')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('orderHistory.amount')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(" ￥" + _toDisplayString(_ctx.baseInfo.current_price / 100), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('orderHistory.payType')), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('confirmOrder.paySupportDesc')), 1),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payTypes, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["pay-type-item", { active: item.isCheck }]),
          key: index,
          onClick: ($event: any) => (_ctx.checkPayType(index))
        }, [
          _createElementVNode("img", {
            src: item.icon,
            alt: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.describe), 1)
          ])
        ], 10, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('confirmOrder.protocolSectionTitle')), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('confirmOrder.protocolReadPrompt')), 1),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.isCheckedProtocol,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCheckedProtocol) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('confirmOrder.paymentTermsLinkText')), 1)
    ])
  ]))
}